import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IEducationalSymbolPayload,  IInitialStateSymbol} from "../types";
import {GetDeleteEducationalSymbols, GetEducationalSymbols} from "./thunk";




const initialState:IInitialStateSymbol = {
    educationalSymbols:[],
    filteredSymbols:[],
    isLoadingSymbols: false,
    educationalSymbolsRestore:[],
    isViewEducationalSymbolsRestore:false,
    selectedSymbolsIDs:[]
}

const educationalSymbolsSlice = createSlice({
    name:"educationalSymbols",
    initialState,
    reducers:{
        setEducationalSymbols(state, action:PayloadAction<{data:IEducationalSymbolPayload[],defaultLanguage:string}>) {
            const {data,defaultLanguage} = action.payload;
            state.educationalSymbols= data
           state.filteredSymbols = data.flatMap((item: any) =>
                item.translations
                    .filter((elem: any) => elem.slug === defaultLanguage)
                    .map((translation: any) => ({
                        id: item.id,
                        symbol: item.symbol,
                        name: translation.name
                    }))
            );

        },
        deletedEducationalSymbols: (state, action: PayloadAction<number>) => {
            state.educationalSymbols = state.educationalSymbols.filter(
                (elem) => elem.id !== action.payload
            );
        },
        updateEducationalSymbols: (
            state,
            action: PayloadAction<IEducationalSymbolPayload>
        ) => {
            const updateData = action.payload;

            state.educationalSymbols = state.educationalSymbols.map(
                (elem) => {
                    if (elem.id === updateData.id) {
                        return {
                            ...elem,
                            ...updateData,
                        };
                    }
                    return elem;
                }
            );
        },
        setSelectedSymbolsIDs: (state, action) => {
            state.selectedSymbolsIDs = action.payload
        },

        setEducationalSymbolsRestore:(state, action) => {
            state.educationalSymbolsRestore = action.payload;
        },
        setIsViewEducationalSymbolsRestore:(state)=>{

            state.isViewEducationalSymbolsRestore =!state.isViewEducationalSymbolsRestore;
        },
    },
    extraReducers:builder => {
        builder.addCase(GetEducationalSymbols.pending, (state) => {
            state.isLoadingSymbols = true;
        })
            .addCase(
                GetEducationalSymbols.fulfilled,
                (state) => {
                    state.isLoadingSymbols = false;

                }
            )
            .addCase(GetEducationalSymbols.rejected, (state) => {
                state.isLoadingSymbols = false;
            })
            .addCase(GetDeleteEducationalSymbols.pending, (state) => {
                state.isLoadingSymbols = true;
            })
            .addCase(
                GetDeleteEducationalSymbols.fulfilled,
                (state) => {
                    state.isLoadingSymbols = false;

                }
            )
            .addCase(GetDeleteEducationalSymbols.rejected, (state) => {
                state.isLoadingSymbols = false;
            })
    }

})
export const{
    setEducationalSymbols,
    deletedEducationalSymbols,
    updateEducationalSymbols,
    setEducationalSymbolsRestore,
    setIsViewEducationalSymbolsRestore,
    setSelectedSymbolsIDs
} =educationalSymbolsSlice.actions
export default educationalSymbolsSlice